import type { SVGProps } from 'react';

/** Sweden — blue field with a yellow Nordic cross. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const SeFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#006AA7" />
        <rect y="12" width="60" height="6" fill="#FECC00" />
        <rect x="12" width="6" height="30" fill="#FECC00" />
    </svg>
);
